import React from "react";

export const MenuDrag = React.forwardRef<SVGSVGElement, React.SVGAttributes<SVGElement>>(function MenuDrag(props, ref) {
	return (
		<svg ref={ref} width={40} height="4" {...props}>
			<use xlinkHref="#icon-menu_drag"></use>
		</svg>
	);
});
